export default "__VITE_ASSET__CZoVdvJ$__$_?url__"